import styled from "styled-components";
import * as M from "@mui/material";
import "react-quill/dist/quill.snow.css";

export const Container = styled(M.Container)`
  && {
    padding: 0 20px;
  }
`;

export const TableContainer = styled(M.TableContainer)`
  && {
    overflow-x: visible !important; /* 스크롤바 제거 */
  }
`;

export const Typography = styled(M.Typography)`
  && {
    font-size: 23px;
    margin: 20px 0 15px 0;
    font-weight: 700;
  }
`;

export const Paper = styled(M.Paper)`
  && {
    margin-bottom: 20px;
    min-height: 200px;
    background-color: #f9f9f9;
    border: 1px solid #ededed;
  }
`;

export const Input = styled(M.Input)`
  width: 250px;
  height: 2em;
  border-radius: 4px;
  border: 1px solid lightgrey;
  padding: 0 10px;

  &&::before {
    content: none; // 기본 밑줄 제거
  }

  &&::after {
    content: none; // 포커스 시 밑줄 제거
  }
`;

export const InputLabel = styled(M.InputLabel)`
  && {
    width: 100px;
    margin-right: 15px;
    font-family: NanumGothic;
    font-size: 15px;
    color: #000000;
    font-weight: 700;
  }
`;

export const Select = styled(M.Select)`
  && {
    width: 250px;
    height: 2em;
    font-size: 14px;
    background-color: #ffffff;
  }
`;

export const RadioGroup = styled(M.RadioGroup)`
  && {
    align-items: center;
  }
`;

export const MenuItem = styled(M.MenuItem)`
  && {
    width: 250px;
    font-size: 14px;
  }
`;

export const NormalButton = styled(M.Button)`
  && {
    height: 2.5em;
    border: none;
    background-color: #e0e0e0;
    color: #000000;
    box-shadow: none;
    margin-right: 5px;
    width: 80px;
  }

  &&:hover {
    background-color: #969696;
    color: white;
  }
`;

export const SaveButton = styled(M.Button)`
  && {
    height: 2.5em;
    border: none;
    background-color: #8989db;
    color: #ffffff;
    width: 80px;
  }

  &&:hover {
    background-color: #6565d1;
  }
`;

export const Table = styled(M.Table)``;

export const TableBody = styled(M.TableBody)``;

export const TableRow = styled(M.TableRow)`
  && {
    background-color: #ffffff;
    height: 2.5em;
    border: 1px solid #ebebebeb;
  }
`;

export const TableCell = styled(M.TableCell)`
  && {
    height: 2em;
    font-size: 14px;
    padding: 7px;
    border-bottom: none;
  }

  &:nth-of-type(odd) {
    background-color: #f9f9f9;
    font-weight: bold;
  }

  &:nth-child(even) {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;

export const AuthTitleCell = styled(M.TableCell)`
  && {
    height: 2em;
    font-size: 14px;
    padding: 7px;
    border-bottom: none;
    text-align: center;
    font-size: 15px;
    font-weight: 700;
    border-right: 1px solid #ebebebeb;
  }
  &:last-child {
    border-right: none; // 마지막 셀에서는 오른쪽 세로줄 제거
  }
`;

export const AuthTableCell = styled(M.TableCell)`
  && {
    height: 2em;
    font-size: 14px;
    padding: 7px;
    border-bottom: none;
    border-right: 1px solid #ebebebeb;
  }

  &:last-child {
    border-right: none; // 마지막 셀에서는 오른쪽 세로줄 제거
  }
`;

export const TableCellWithButton = styled(TableCell)`
  && {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: none;
    height: 100%;
  }
`;

export const TextField = styled(M.TextField)`
  && {
    width: 100%;
    .MuiInputBase-root {
      border-radius: 4px;
      background-color: #fff; // 배경색 변경
    }
    .MuiOutlinedInput-input {
      padding: 12px; // 패딩 조정
    }
    .MuiOutlinedInput-notchedOutline {
      border-color: lightblue; // 테두리 색상 변경
    }
    .MuiInputLabel-root {
      color: grey; // 라벨 색상 변경
    }
    .Mui-focused {
      .MuiOutlinedInput-notchedOutline {
        border-width: 2px; // 포커스 시 테두리 두께 변경
        border-color: darkblue; // 포커스 시 테두리 색상 변경
      }
      .MuiInputLabel-root {
        color: darkblue; // 포커스 시 라벨 색상 변경
      }
    }
  }
`;

export const BtnBox = styled(M.Box)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const Image = styled.img`
  width: 250px;
  max-height: 200px;
  margin-top: 15px;
`;

export const Text = styled(M.Typography)`
  && {
    font-size: 14px;
  }
`;

export const Checkbox = styled(M.Checkbox)`
  color: #ffffff; // 기본 색상 설정
`;

export const Editor = styled.div`
  .quill {
    .ql-toolbar {
      background: #f3f3f3;
      border-radius: 4px 4px 0 0;
    }
    .ql-container {
      border-radius: 0 0 4px 4px;
      border-top: none;
      height: 200px;
    }
  }
`;
